module.exports = __webpack_public_path__ + "static/media/OurStory-TanBlockMobile.b3a3f864.svg";